/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useT } from 'talkr';
import s from './index.module.scss';
import bg3 from './img/short_3.jpg';
import ActionBar from '../../components/actionBar';

function TrainYourDog() {
  const { T } = useT();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: 'IS_STATUSBAR_TRANSPARENT',
      payload: true,
    });
  });

  return (
    <div className={s.trainYourDog}>
      <div className={s.trainYourDog_text}>
        <div
          className={s.trainYourDog_description}
          dangerouslySetInnerHTML={{ __html: T('trainYourDog_description') }}
        />
      </div>
      <img className={s.trainYourDog_bg} src={bg3} alt={s.welcome} />
      <div className={s.trainYourDog_shadow} />
      <ActionBar currentStepCompleted show transparentBg />
    </div>
  );
}

export default TrainYourDog;
